// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1keRQ","badges":"styles_badges__2bfZg"};